import { useRef } from "react";
export function useSyncedRef(value) { const ref = useRef(value); ref.current = value; return ref; }
